import { forwardRef } from 'react';
import type { CSSProperties, HTMLAttributes } from 'react';
import { cx } from '../utils/cx.js';
import { spaceVar } from '../utils/space.js';
import type { SpaceToken } from '../utils/space.js';
import styles from './Inline.module.css';

export interface InlineProps extends HTMLAttributes<HTMLDivElement> {
  /** A key on the --space-* scale. Defaults to 4 (12px). */
  gap?: SpaceToken;
  wrap?: boolean;
  align?: CSSProperties['alignItems'];
  justify?: CSSProperties['justifyContent'];
}

export const Inline = forwardRef<HTMLDivElement, InlineProps>(function Inline(
  { gap = 4, wrap = false, align = 'center', justify, className, style, ...rest },
  ref,
) {
  return (
    <div
      ref={ref}
      className={cx(styles.inline, wrap && styles.wrap, className)}
      style={{ gap: spaceVar(gap), alignItems: align, justifyContent: justify, ...style }}
      {...rest}
    />
  );
});
